import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertCircle } from 'lucide-react';
import MainHeader from '../MainHeader';
import Footer from '../Footer';
import NotFound from './../NotFound';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = 'Propyn - Page Not Found';
  }, []);

  return (
    <>
      <MainHeader />
      <div className="max-w-7xl mx-auto px-2 lg:px-0 pt-6 pb-12">
        <div className="min-h-[60vh] flex flex-col justify-center">
          <NotFound 
            title="404 - Page Not Found"
            message="We couldn't find the page you're looking for. It might have been moved or doesn't exist."
            icon={<AlertCircle className="w-12 h-12 text-white" />}
          />
          
          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center mt-4">
            <Link 
              to="/" 
              className="inline-flex items-center gap-x-2 bg-gradient-to-r from-[#24ccf2] to-[#2476f2] text-white font-medium rounded-full px-6 py-3 hover:shadow-lg transition-all duration-300"
            >
              <Home className="size-5" />
              Return Home
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFoundPage;